// scss
import './../scss/main.scss';
//js
import './genarel';
import './mobileNav';
import './testimonals';
import './subscriptions';

// importing assets folder
import heroBackGroundImg from '../assets/hero-backgroundImg.jpg';
import mapImg from '../assets/map-img.jpg';

import servicesImg1 from '../assets/services-imgs/build-health.jpg';
import servicesImg2 from '../assets/services-imgs/build-muscle.jpg';
import servicesImg3 from '../assets/services-imgs/build-skills.jpg';
import servicesImg4 from '../assets/services-imgs/build-strength.jpg';

import memberFace1 from '../assets/members-quotes-imgs/testimonal-1.jpg';
import memberFace2 from '../assets/members-quotes-imgs/testimonal-2.png';
import memberFace3 from '../assets/members-quotes-imgs/tes.png';

import tourBackground from '../assets/tour-imgs/gymTour-background.jpg';
import tourimg from '../assets/tour-imgs/gymTourImg.jpg';
import tourBackgroundImg from '../assets/tour-imgs/gymTour-background.jpg';
import svgs from '../assets/icons.svg';
